export default "__VITE_ASSET__c612575a__"